var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 420",
    width: 480,
    height: 420,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "public-service-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m207.4 0.9c-10.5 2.7-20.6 11.6-24.2 21.4-6.5 17.2 0.9 35.7 17.6 43.9 5.9 2.9 7.6 3.3 14.7 3.3 7.1 0 8.8-0.4 14.7-3.3 21.4-10.5 26.6-37.2 10.7-54.7-6.6-7.1-13.7-10.5-23.3-11-3.9-0.3-8.5-0.1-10.2 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m396.4 0.9c-6.4 1.6-12.5 5.4-17.3 10.7-15.9 17.4-10.7 44.1 10.7 54.6 5.9 2.9 7.6 3.3 14.7 3.3 7.1 0 8.8-0.4 14.7-3.3 21.4-10.5 26.6-37.2 10.7-54.7-6.6-7.1-13.7-10.5-23.3-11-3.9-0.3-8.5-0.1-10.2 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m301.7 27c-9.9 2.5-19.1 10.3-23.5 19.8-2.2 4.8-2.7 7.1-2.7 14.2 0 10.4 2.9 17.4 10 24.5 7.1 7.1 14.1 10 24.5 10 10.4 0 17.4-2.9 24.5-10 7.1-7.1 10-14.1 10-24.5 0-7.1-0.5-9.4-2.7-14.2-3.3-7.2-10.3-14.2-17.3-17.4-6.1-2.8-16.7-3.9-22.8-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m199.6 91.6c-26.7 5.9-48.4 26.2-56.5 52.7-2.7 9-3.7 21.2-2.1 26.1 4.8 14.7 31.5 24.8 68 25.8l11.5 0.3 0.7-11c0.7-12.7 3.3-22.8 8.6-33.4 6.8-14 18.4-27 31.2-35.2 3.8-2.4 6.8-4.9 6.6-5.4-0.5-2-12.1-10.5-19-13.9-3.9-1.9-9.8-4.2-13.1-5.1-8.7-2.4-27.3-2.8-35.9-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m389 91.5c-7.8 1.7-15.5 4.7-23 9.1-5.8 3.4-14.9 10.9-14 11.6 0.3 0.2 3.2 2.1 6.5 4.2 7.8 5.1 19.7 16.6 24.7 23.9 9.8 14.4 14.6 28.3 15.6 45.2l0.7 11 11.5-0.3c36.5-1 63.2-11.1 68-25.8 1.6-4.9 0.6-17.1-2.1-26.1-6.7-21.9-24.2-41.2-44.5-49.2-12.6-4.9-30.2-6.4-43.4-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m295 117.5c-34.6 7.8-60 37.7-60 70.8 0 10 2.4 14.7 10.2 20 32.9 22.5 122.6 17.4 137.3-7.8 6.6-11.2 0.4-37.7-13-55.4-9-11.8-25.1-22.5-40-26.6-8.5-2.3-26.4-2.8-34.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m164.5 224.1c-7.7 1.7-16.2 5.3-42 17.7-14.3 6.8-28.5 13.6-31.5 14.9-3 1.4-5.6 2.6-5.8 2.8-0.3 0.3 38 93 39.7 96.2 0.4 0.9 3.7-0.3 11.1-3.8 12.5-6 22-8.3 30.5-7.3 3.2 0.3 23.5 5.8 45 12.1 22.8 6.6 41.7 11.6 45.5 12 13.7 1.2 26.2-2.2 67.8-18.1 77.3-29.7 127-49 130.2-50.6 4.9-2.5 12.6-11 15.2-16.7 1.6-3.5 2.2-6.9 2.2-12.3 0.1-9.2-2.2-13.6-9.2-17.8-4.2-2.4-5.9-2.7-15.8-3-14.7-0.5-17.9 0.2-73.9 16.6l-47 13.8-0.8 6.4c-1.6 14.4-11.3 27-24.4 32-11.1 4.2-15.2 3.6-66.2-10.2-40.9-11.1-45.6-12.6-47.4-14.9-2.5-3.4-1.3-7.8 2.6-9.7 2.4-1.2 7.1-0.1 47.9 10.9 47 12.7 52 13.6 58.8 10.7 9.3-3.9 14.4-11.7 14.4-21.8 0-9.1-4.4-16.8-11.9-20.8-1.6-0.8-18.4-5.7-37.3-10.8-33.1-8.9-34.5-9.3-42-14.2-9.4-6.2-20.6-11.5-28.8-13.6-6.7-1.7-20.4-2-26.9-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "currentColor",
    d: "m27 243.1c-10.8 4.5-20.7 9.2-22.2 10.7-3.4 3.1-5.2 8.3-4.5 12.6 0.9 5.3 60.4 146.7 62.8 149.2 2.8 3 8.2 4.8 12.3 4.1 5-0.8 39.9-15.6 42.4-18 3.3-3 5.2-7 5.2-10.7 0-3.3-58.6-145.5-61.9-150-2.2-3.2-7.7-6-11.6-6-1.6 0-11.8 3.7-22.5 8.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.209dec94f4040a1619979ad782518ba8.svg";
export { ForwardRef as ReactComponent };